import { useState, useEffect } from 'react';

/**
 * Preferências de listagem de Workflows persistidas em localStorage.
 * Espelha modules/users/hooks/useUserPreferences para o padrão-lista (view toggle).
 */
const STORAGE_KEYS = {
  VIEW_MODE: 'workflows_view_mode',
} as const;

export type WorkflowViewMode = 'grid' | 'table';

export const useWorkflowPreferences = () => {
  const [viewMode, setViewModeState] = useState<WorkflowViewMode>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.VIEW_MODE);
      return (stored as WorkflowViewMode) || 'grid';
    } catch {
      return 'grid';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEYS.VIEW_MODE, viewMode);
    } catch (error) {
      console.error('Erro ao salvar viewMode no localStorage:', error);
    }
  }, [viewMode]);

  return {
    viewMode,
    setViewMode: setViewModeState,
  };
};
